import { render, staticRenderFns } from "./edit-monetary-amount.vue?vue&type=template&id=ccb3192e&scoped=true&"
import script from "./edit-monetary-amount.vue?vue&type=script&lang=js&"
export * from "./edit-monetary-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb3192e",
  null
  
)

export default component.exports